export default __webpack_public_path__ + "static/media/studio2020_2.2f312e7b.jpeg";